module.exports = "/_next/static/images/isolatieglas-26a5bcb0b867c11a1ce06e232ec9604a.jpg";